export default function SetLoginToken(body) {
    sessionStorage.setItem("LOGIN_TOKEN", body['token']);
    sessionStorage.setItem("USER_CODE", body['code']);
    sessionStorage.setItem("USER_TYPE", body['type']);

    localStorage.setItem("LOGIN_TOKEN", body['token']);
    localStorage.setItem("USER_CODE", body['code']);
    localStorage.setItem("USER_TYPE", body['type']);
}